export default __webpack_public_path__ + "static/media/cbse_logo.a08dc5f8.png";